import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class Blogs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            item: this.props.item
        };
    }

    createMarkup = (html) => {
        if (html.search("&#8230") !== -1) {
            html = html.slice(0, html.search("&#8230") + 6);
        }
        return { __html: html };
    }

    replacestring = (title) => {
        title = title.replace("http://157.230.224.112/", "")
        title.substring(0, title.length - 1);

        return title;
    }

    render() {
        var divStyle = {
            backgroundImage: 'url(' + this.props.item.image + ')',
            // backgroundSize: 'cover'
        };

        return (
            <div className="col-sm-6 col-md-6 blogCard-container">
                <Link to={'/blogdetails/' + this.replacestring(this.props.item.link)} className="blogCard" >
                    <h5 className="blogCardTitle">{this.props.item.title}</h5>
                    <div className="blogCard-image-container">
                        <img style={divStyle} className="blogCard-image" />
                    </div>
                    <p className="">
                    </p>
                    <p className="blogCardText" dangerouslySetInnerHTML={this.createMarkup(this.props.item.description)}></p>
                </Link>
            </div>
        );
    }
}